<template>

    <div id="user-guide">
        <Documentation></Documentation>
    </div>

</template>

<script>
import Documentation from "./Documentation";

export default {
    name: "UserGuide",
    components: {
        Documentation
    }
}
</script>
